<script lang="ts">
    import type InstagramStoryEntity from "@apps/instagram/entities/InstagramStoryEntity";

    import Icon from "@components/Icon.svelte";
    import Image from "@components/Image/Image.svelte";

    import InstagramIcon from "../icons/InstagramIcon.svelte";

    export let story: InstagramStoryEntity;
</script>

<div class="gw-ig-story-modal-image">
    <Image
        alt={story.id.toString()}
        wrapperClassName="gw-ig-story-modal-image__img"
        src={story.photoUrl}
        objectFit="contain"
        on:imageLoaded
    >
        <Icon slot="backdrop" class="gw-ig-story-modal-image__icon">
            <InstagramIcon />
        </Icon>
    </Image>
</div>

<style>
    .gw-ig-story-modal-image {
        display: flex;
        position: relative;
        align-items: center;
        height: 100%;
    }
    .gw-ig-story-modal-image :global(.gw-ig-story-modal-image__img) {
        display: block;
        width: 100%;
        height: 100%;
    }
    .gw-ig-story-modal-image :global(.gw-ig-story-modal-image__icon) {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        height: 100px;
        transform: translateX(-50%) translateY(-50%);
        color: #ccc;
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 var(--gw-ig-modal-tag-shadow-main-color);
        }
        70% {
            box-shadow: 0 0 0 20px
                var(--gw-ig-modal-tag-shadow-transparent-color);
        }
        100% {
            box-shadow: 0 0 0 0 var(--gw-ig-modal-tag-shadow-transparent-color);
        }
    }
</style>
